module.exports = __webpack_public_path__ + "img/icon_ticket2.377a2797.svg";